import { z } from "zod";

export const transferBillingFormSchema = z.object({
    newPrimaryAdminId: z.number().min(1, "New primary admin is required"),
});

export type TransferBillingFormSchema = z.infer<
    typeof transferBillingFormSchema
>;
